import classes from "./FooterAds.module.scss";
import AdUnit, { AdUnitTypeEnum } from "./AdUnit";
import { FooterEnum } from "./config/units/footer";

export const FooterAds = () => {
  return (
    <div className={classes.footerAds}>
      <AdUnit name={FooterEnum.DesktopIndexFooterA} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.DesktopIndexFooterB} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.DesktopIndexFooterC} type={AdUnitTypeEnum.DESKTOP} />
      <AdUnit name={FooterEnum.MobileFooter} type={AdUnitTypeEnum.MOBILE} />
    </div>
  );
};
